import { Link } from "react-router-dom";
import type { VideoItem } from "@/types";
import { typeLabels } from "@/mocks/filters";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面海报`}
          title={`${video.title} - CC视频影视详情`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-50/90 text-primary-700 text-xs font-medium">
          {typeLabels[video.type]}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {video.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-medium text-foreground-950 text-sm truncate group-hover:text-primary-700 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {video.year} · {video.region}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {video.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px]"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}